import { useAuth } from "@/context/AuthContext";
import TwoFactorSetup from "@/pages/TwoFactorSetup";
import { SwanLogo, TaglineDivider } from "@/components/Brand";
import { ShieldCheck } from "lucide-react";

export default function ForceSetup2FA() {
  const { refresh, logout } = useAuth();
  return (
    <div className="swan-bg min-h-screen flex flex-col items-center justify-center px-5 py-10">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center text-center mb-2">
          <SwanLogo size={72} />
        </div>
        <TaglineDivider />
        <div className="card-surface rounded-2xl p-6 mt-4">
          <div className="w-12 h-12 rounded-xl bg-[#C9A84A] flex items-center justify-center mb-4">
            <ShieldCheck className="text-[#0A0F1F]" size={26} />
          </div>
          <h2 className="font-serif font-bold text-2xl text-white mb-1">Secure your account</h2>
          <p className="text-slate-400 mb-5 text-sm">
            Two-factor authentication is required for practice team accounts. Set it up now to continue.
          </p>
          <TwoFactorSetup onDone={refresh} />
        </div>
        <button onClick={logout} className="w-full text-center text-slate-400 text-sm mt-5 hover:text-white">
          Sign out
        </button>
      </div>
    </div>
  );
}
